import { apiCall } from "../helper/Common";

/**
 * POST /api/client/onboarding — session token auth; server uses JWT shop → client id.
 */
export async function postOnboardingStatus(isOnBoarding) {
  const payload = await apiCall("client/onboarding", "POST", {
    is_on_boarding: String(isOnBoarding),
  });
  return payload;
}
